export default {
  login: {
    title: 'Redireccionando...',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/auth/login.js